import formatMinutesSeconds from './formatMinutesSeconds';

export default function formatNextUpdate(lastUpdate, reportInterval) {
  const lastUpdateDate = new Date(lastUpdate);
  const nowInSecs = Date.now() / 1000;
  const lastUpdateInSecs = lastUpdateDate.getTime() / 1000;
  const nextUpdateInSecs = lastUpdateInSecs - nowInSecs + reportInterval;

  if (nextUpdateInSecs < 0) return 'Now';

  return formatMinutesSeconds(nextUpdateInSecs, { useClockFormat: true });
}



// WEBPACK FOOTER //
// ./src/helpers/formatNextUpdate.js